var MfxWishlist = {
  key: 'mfx_wishlist',

  get: function() {
    try { return JSON.parse(localStorage.getItem(this.key)) || []; }
    catch(e) { return []; }
  },

  save: function(list) {
    localStorage.setItem(this.key, JSON.stringify(list));
  },

  has: function(id) {
    return this.get().some(function(p) { return p.id == id; });
  },

  add: function(product) {
    var list = this.get();
    if (!this.has(product.id)) { list.push(product); this.save(list); }
  },

  remove: function(id) {
    var list = this.get().filter(function(p) { return p.id != id; });
    this.save(list);
  },

  toggle: function(product) {
    if (this.has(product.id)) { this.remove(product.id); return false; }
    else { this.add(product); return true; }
  },

  initButtons: function() {
    document.querySelectorAll('[data-wishlist-id]').forEach(function(btn) {
      var id = btn.getAttribute('data-wishlist-id');
      if (MfxWishlist.has(id)) btn.classList.add('mfx-wl-active');
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var product = {
          id: btn.getAttribute('data-wishlist-id'),
          title: btn.getAttribute('data-wishlist-title'),
          price: btn.getAttribute('data-wishlist-price'),
          url: btn.getAttribute('data-wishlist-url'),
          image: btn.getAttribute('data-wishlist-image')
        };
        var added = MfxWishlist.toggle(product);
        btn.classList.toggle('mfx-wl-active', added);
        btn.innerHTML = added ? '♥' : '♡';
        if (navigator.vibrate) navigator.vibrate(40);
      });
    });
  }
};

document.addEventListener('DOMContentLoaded', function() {
  MfxWishlist.initButtons();
});